import template from '../../../../../../ui-formly/partials/form.html'
import FormControllerFactory from '../../../../../../ui-formly/controllers/FormControllerFactory'
import server from '../../../../Server/index'
import fields from './formly'

machineConfigure.vsName = 'machineConfigure'
machineConfigure.vsNgType = 'directive'

machineConfigure.$inject = [server.vsName]
function machineConfigure(server) {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model: '='
    },
    controller: FormControllerFactory({
      returnState: '^.configurations',
      formFields: fields,
      submit: server.machineConfigure,
      showButtonsAtTop: true
    }),
    controllerAs: 'ctrl',
    bindToController: true
  }
}

export default machineConfigure
